/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_NoteInputs */

const vi_tea_purchase_note = /** @type {(inputs: Tea_Purchase_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi chú`)
};

/**

* @param {Tea_Purchase_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_note = /** @type {((inputs?: Tea_Purchase_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_note(inputs)
});